import React, {PropTypes, Component } from 'react';
import { Link } from 'react-router-dom';

class Header extends Component {
  static propTypes = {
    cities: PropTypes.array.isRequired,
  };

  render(){
    return (
        <div id="stuck_container">
          <header>
            <div className="container">
              <div className="row">
                <article className="col-lg-12 col-md-12 col-sm-12">
                    <h1 className="navbar-brand navbar-brand_"><a className="home" href="/" >DASH 9 Home</a></h1>
                  <div className="menuBox clearfix">
                    <nav className="navbar navbar-default navbar-static-top tm_navbar clearfix" role="navigation">
                      <ul className="nav sf-menu clearfix">
                        <li><Link className="page-scroll" to="/">Home</Link></li>
                        <li><Link className="page-scroll" to="/puzzles">Puzzles</Link></li>
                        <li><Link className="page-scroll" to="/credits">Credits</Link></li>
                         <li className="sub-menu"><a href="#locations">Locations</a>
                          <ul className="submenu">
                              {this.cityLinks()}
                          </ul>
                        </li>
                        <li><a className="page-scroll" href="http://playdash.org">DASH Home</a></li>
                      </ul>
                    </nav>
                  </div>
                </article>
              </div>
            </div>
          </header>
       </div>
    );
  }

  cityLinks() {
    return this.props.cities.map( (city) => this.cityLink(city));
  }

  cityLink(city) {
    return (
    <li key={"sub-menu-" + city.slug } ><Link to={`/city-${city.slug}`} >{city.name}</Link></li>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Header.js